/**
 * Phase 2 Feature H — condition-centric temporal profile.
 */

import { FEATURE_TYPES } from './ddxTemporalTaxonomy.js';
import { temporalFitScore } from './ddxKbProjection.js';

/**
 * @param {string} diagnosisId
 * @param {{ bucket?: string }} temporalContext
 * @param {{ getDiagnosis: (id: string) => object | null, edges: object[] }} graph
 */
export function generateConditionLookup(diagnosisId, temporalContext, graph) {
  const dx = graph.getDiagnosis(diagnosisId);
  const acuity = temporalContext?.bucket || 'indeterminate';
  const edges = (graph.edges || []).filter((e) => e.diagnosisId === diagnosisId);

  /** @type {Record<string, object[]>} */
  const byFeatureType = {};
  for (const ft of Object.values(FEATURE_TYPES)) byFeatureType[ft] = [];
  for (const e of edges) {
    const ft = e.featureType || 'symptom';
    if (!byFeatureType[ft]) byFeatureType[ft] = [];
    byFeatureType[ft].push({
      ...e,
      temporalFit: temporalFitScore(acuity, e.temporalBuckets),
    });
  }

  return {
    diagnosisId,
    label: dx?.label || dx?.name || diagnosisId,
    temporalSignature: dx?.temporalSignature || dx?.temporalBuckets || null,
    demographicModifiers: dx?.demographicModifiers || [],
    contextModifiers: dx?.contextModifiers || [],
    historyProfile: byFeatureType[FEATURE_TYPES.SYMPTOM].concat(
      byFeatureType[FEATURE_TYPES.HISTORY_MEDICAL],
      byFeatureType[FEATURE_TYPES.HISTORY_SOCIAL]
    ),
    examProfile: [
      ...byFeatureType[FEATURE_TYPES.EXAM_GENERAL],
      ...byFeatureType[FEATURE_TYPES.EXAM_FOCUSED],
      ...byFeatureType[FEATURE_TYPES.EXAM_VITAL],
    ],
    diagnosticProfile: [
      ...byFeatureType[FEATURE_TYPES.DIAGNOSTIC_LAB],
      ...byFeatureType[FEATURE_TYPES.DIAGNOSTIC_IMAGING],
      ...byFeatureType[FEATURE_TYPES.DIAGNOSTIC_ECG],
      ...byFeatureType[FEATURE_TYPES.DIAGNOSTIC_OTHER],
    ],
  };
}
